<script lang="ts">
    import type { EnumSetting } from "..";

    export let setting: EnumSetting;
</script>

<!----------------------------------------------------------------------------->

<select id={setting.id} bind:value={setting.value}>
    {#each setting.options as option}
        <option value={option.value} selected={option.value === setting.value}>
            {option.name}
        </option>
    {/each}
</select>

<!----------------------------------------------------------------------------->

<style>
    select {
        width: max-content;
    }
</style>
